import angular from 'angular';
import accountModule from '../../../app.js';
import BankingService from '../../../services/banking-service.js';
import US_STATES from '../../../data/us.states.js';
import CA_PROVINCES from '../../../data/ca.provinces.js';
import NZ_STATES from '../../../data/nz.states.js';
import GB_COUNTIES from '../../../data/gb.counties.js';

import {BusinessTaxIdValidationFactory,
    BusinessTaxIdConfigsFactory,
    BusinessTaxIdFormatterFactory,
    PhoneNumberFormatter,
    AddressFormatterFactory,
    AddressConfigsFactory,
    commonUtil,
    configManager,
    localeUtil,
    qas,
    strings,
    userProfileManager,
    Account,
    Sponsor,
    LegacyAccountAdaptor,
    BusinessTaxIdUtilsFactory,
    AccountConfigManager} from '@nuskin/ns-common-account';

import '../profile.scss';

accountModule.service('addressFormatterFactory', function() {
    return AddressFormatterFactory;
});
accountModule.service('addressConfigsFactory', function() {
    return AddressConfigsFactory;
});
accountModule.service('businessTaxIdValidationFactory', function() {
    return BusinessTaxIdValidationFactory;
});
accountModule.service('businessTaxIdConfigsFactory', function() {
    return BusinessTaxIdConfigsFactory;
});
accountModule.service('businessTaxIdFormatterFactory', function() {
    return BusinessTaxIdFormatterFactory;
});
accountModule.service('bankingService', function() {
    return BankingService;
});
accountModule.service('businessTaxIdUtilsFactory', function() {
    return BusinessTaxIdUtilsFactory;
});
accountModule.service('configManager', function() {
    return configManager;
});
accountModule.service('AccountConfigManager', function() {
    return AccountConfigManager;
});
accountModule.service('strings', function() {
    return strings;
});


accountModule.controller('businessController', ['businessService',
    'addressFormatterFactory',
    'addressConfigsFactory',
    'bankingService',
    'businessTaxIdValidationFactory',
    'businessTaxIdConfigsFactory',
    'businessTaxIdFormatterFactory',
    '$scope',
    '$timeout',
    '$window',
    '$rootScope',
    '$filter',
    '$uibModal',
    '$sce',
    'bankService',
    'businessTaxIdUtilsFactory',
    'strings',
    'configManager',
    'AccountConfigManager',
    function(businessService,
        addressFormatterFactory,
        addressConfigsFactory,
        bankingService,
        businessTaxIdValidationFactory,
        businessTaxIdConfigsFactory,
        businessTaxIdFormatterFactory,
        $scope,
        $timeout,
        $window,
        $rootScope,
        $filter,
        $uibModal,
        $sce,
        bankService,
        businessTaxIdUtilsFactory,
        strings,
        configManager,
        AccountConfigManager) {
        var accountConfigManager = AccountConfigManager.getConfig(configManager);
        var countryCode = accountConfigManager.site['countryCode'];
        var languageCode = accountConfigManager['languageCode']; // injected from the wrapper
        var addressConfigs = addressConfigsFactory.getAddressConfigs(countryCode);
        var addressFormatter = addressFormatterFactory.getAddressFormatter(countryCode);
        var serviceCallFailureMsg = strings.get('tdc_serviceCallFailureMsg');
        var self = this;
        var model = self.model = {};
        model.currentTab = 'overview';
        model.isBusinessSelected = true;
        model.isPersonalSelected = false;
        model.contactPreferenceSelection = {};
        model.invalidTaxID = false;
        model.duplicateTaxID = false; /* WRT MEC-9629*/
        model.duplicateTaxIDActive = false;
        model.duplicateTaxIDInActive = false;
        model.mobileAddress = 'account-mobile';
        model.desktopAddress = 'account-desktop';
        model.hideDirectDeposit = accountConfigManager.site['hideDirectDeposit'];
        model.abnRequired = false;
        model.abnNumber = '';
        model.gstNumber = '';
        model.showAccountDetailsForm = false;
        model.showEditbutton = false;
        model.bankAccounts=[];
        model.addressConfigs = addressConfigs;
        model.addressFormatter = addressFormatter;
        model.isBussEnabled = false;
        model.isSuccess = false;
        model.qasAddress = {};
        this.isEnteredAddressCannotBeIdentified = true;
        var emailLabel = strings.get('tdc_commemailtext');
        var textLabel = strings.get('tdc_commtextlabel');
        var notSpecifiedLabel = strings.get('tdc_notSpecified');

        model.zipMaxLength = model.zipMinLength = null;
        model.setShowMore = false;
        var mask;
        var lenIban;
        // var bankingService = BankingService();
        // Get Market-specific data
        switch (countryCode) {
        case 'CA':
            model.stateList = CA_PROVINCES;
            model.zipMaxLength = 7;
            model.zipMinLength = 7;
            var bankListPromise = businessService.getAvailableBanksForMarket(countryCode);
            bankListPromise.then(function(data) {
                model.bankList = data.banks;
            });
            break;
        case 'NZ':
            model.stateList = NZ_STATES;
            model.zipMaxLength = 4;
            model.zipMinLength = 4;
            var bankListPromise = businessService.getAvailableBanksForMarket(countryCode);
            bankListPromise.then(function(data) {
                model.bankList = data.banks;
            });
            break;
        case 'GB':
            model.stateList = GB_COUNTIES;
            model.zipMaxLength = 8;
            model.zipMinLength = 6;
            break;
        default:
            model.stateList = US_STATES;
            model.zipMaxLength = 10;
            model.zipMinLength = 5;
            break;
        }
        mask = businessService.returnMask(countryCode);
        if (mask) {
            lenIban = mask.match(/([*])/gi).length;
            model.mask = mask;
            model.placeHolder = mask.replace(/[*]/gi, '_');
            model.lenIban = lenIban;
        }
        model.countryCode = countryCode;

        model.isBussEnabled = accountConfigManager.site['isBussDistEnabled'];

        var getPersonId = function() {
            return userProfileManager.getUserProfileMasterInfo().userId.toUpperCase();
        };

        self.listSeeMore = strings.get('iItems');
        self.showBusinessDistributorForm = true;

        // overview properties
        model.userInfo = userProfileManager.getUserProfileMasterInfo();
        model.userType = model.userInfo.userType;
        model.hasAccountManager = false;
        model.showContactForm = false;
        model.showAddressForm = false;
        model.showBankingForm = false;
        model.accountOriginal = {};
        model.contactOriginal = {};
        model.addressOriginal = {};
        model.bankingOriginal = {};
        model.userdataOriginal = {};
        model.account = {};
        model.contact = {};
        model.address = {};
        model.displayAddress = {};
        model.banking = {};
        model.hasDirectDepositPolicy = accountConfigManager.site['hasDirectDepositPolicy'];
        model.userdata = {};
        model.address.sameAddressCheckbox = true;
        model.isnameonaccerror = false;
        model.isnameonaccerror = true;
        model.emailInvalid = false;
        model.emailRequired = false;
        model.isPreferredNamePresent = false;
        model.associatesList = [];
        model.language = languageCode;
        model.distInfo = {};
        model.accountManager = {};
        model.associatesLimitAboveMd = 3;
        model.associatesLimitBelowMd = 4;
        self.associatesLimitForIndividualDistributor = 1;
        self.showPref = false;
        self.accSettingsVisible = false;
        // user data processing
        model.userdataOriginal = {};
        model.userdata = {};
        model.loginPref = {};
        model.headerInfo = {};
        model.contactAddress = {};
        model.originalEmailIsOpted;
        model.originalTextIsOpted;
        model.contactPreference = {};
        var termsModalTemplate = 'terms-and-conditions.html';
        var skipForNowModal = 'skipForNowTermsConditions.html';
        var confirmationModalTemplate = 'confirmation-modal.html';
        var addAssociateModalTemplate = 'modalAssociate.html';
        var fileUploadModalTemplate = 'fileuploadmodal.html';
        var cropModalMarkup = 'pictureCropModal.html';
        var addressValidationModalTemplate = 'addressVerification.html';

        self.getElementValue = function(id) {
            var element = angular.element(id);
            if (element != undefined && element != null) {
                return element.val();
            } else {
                return undefined;
            }
        };

        $scope.initGigyaLoginForm = function() {
            if (userProfileManager.isUserLoggedIn()) {
                var userMarket = userProfileManager.returnUserMarket();

                if (userMarket != countryCode) {
                    $window.location.href = localeUtil.replaceUrlLocale(window.location.href, userMarket, languageCode);
                }

                var promise = businessService.getUserGigyaInfo();
                promise.then(function(data) {
                    model.loginPref.username = data.email;

                    model.headerInfo.firstName = data.firstName;
                    model.headerInfo.lastName = data.lastName;
                    model.headerInfo.thumbnailURL = data.thumbnailURL;
                });
                self.bankCheckLinkTitle = strings.get('tdc_bankCheckLinkTitle');
                self.bankCheckTitle = strings.get('tdc_bankCheckTitle');
                self.bankCheckCloseImage = strings.get('bankCheckCloseImage');
                self.bankCheckImage = strings.get('bankCheckImage');
            }
        };

        self.init = function() {
            window.document.title = strings.get('tdc_businessTitle');
            $(window).scrollTop(0);
            $rootScope.$on('show-picture-modal', function(evt, arg) {
                showPictureCropModal(true);
            });
            loadStrings();
            loadBusinessTaxIdConfigs();
            var configData = businessService.getLanguageListFromLocale(countryCode);
            configData.then(function(data) {
                self.model.languageList = data;
                // The loadBusinessDetails has to be loaded after the languageList
                loadBusinessDetails();
            });
            model.address={
                'streetAddress': model.address.streetAddress,
                'streetAddress2': model.address.streetAddress2,
                'city': model.address.city,
                'state': model.address.state,
                'zipcode': model.address.zipcode,
            };
            subscribeEventListeners();
        };

        var subscribeEventListeners = function() {
            /*
                Email Preference checkboxes
             */
            document.getElementById('desktop-lg-business-email').addEventListener('change', function() {
                model.contactPreference.emailIsOpted = this.checked;
            });
            document.getElementById('desktop-sm-business-email').addEventListener('change', function() {
                model.contactPreference.emailIsOpted = this.checked;
            });
            document.getElementById('mobile-lg-business-email').addEventListener('change', function() {
                model.contactPreference.emailIsOpted = this.checked;
            });
            document.getElementById('mobile-sm-business-email').addEventListener('change', function() {
                model.contactPreference.emailIsOpted = this.checked;
            });

            /*
                Text Preference checkboxes
             */
            document.getElementById('desktop-lg-business-text').addEventListener('change', function() {
                model.contactPreference.textIsOpted = this.checked;
            });
            document.getElementById('desktop-sm-business-text').addEventListener('change', function() {
                model.contactPreference.textIsOpted = this.checked;
            });
            document.getElementById('mobile-lg-business-text').addEventListener('change', function() {
                model.contactPreference.textIsOpted = this.checked;
            });
            document.getElementById('mobile-sm-business-text').addEventListener('change', function() {
                model.contactPreference.textIsOpted = this.checked;
            });
        };

        var updateEmailPreferenceAttribute = function(checked) {
            if (checked) {
                document.getElementById('desktop-lg-business-email').setAttribute('checked', '');
                document.getElementById('desktop-sm-business-email').setAttribute('checked', '');
                document.getElementById('mobile-lg-business-email').setAttribute('checked', '');
                document.getElementById('mobile-sm-business-email').setAttribute('checked', '');
            } else {
                document.getElementById('desktop-lg-business-email').removeAttribute('checked');
                document.getElementById('desktop-sm-business-email').removeAttribute('checked');
                document.getElementById('mobile-lg-business-email').removeAttribute('checked');
                document.getElementById('mobile-sm-business-email').removeAttribute('checked');
            }
        };

        var updateTextPreferenceAttribute = function(checked) {
            if (checked) {
                document.getElementById('desktop-lg-business-text').setAttribute('checked', '');
                document.getElementById('desktop-sm-business-text').setAttribute('checked', '');
                document.getElementById('mobile-lg-business-text').setAttribute('checked', '');
                document.getElementById('mobile-sm-business-text').setAttribute('checked', '');
            } else {
                document.getElementById('desktop-lg-business-text').removeAttribute('checked');
                document.getElementById('desktop-sm-business-text').removeAttribute('checked');
                document.getElementById('mobile-lg-business-text').removeAttribute('checked');
                document.getElementById('mobile-sm-business-text').removeAttribute('checked');
            }
        };

        model.showEditButtonBasedOnAccountType = function(accountType, userRole) {
            var showEdit = false;
            if ( ((accountType==userProfileManager.INVITATION_TYPE.INDIVIDUAL
                    || accountType==userProfileManager.INVITATION_TYPE.RETAILER)
                    && userRole==userProfileManager.USER_ROLE.PRIMARY
                    && model.associatesListOriginal.length == 1)
                || (accountType==userProfileManager.INVITATION_TYPE.INDIVIDUAL
                || accountType==userProfileManager.INVITATION_TYPE.RETAILER)
                && model.associatesListOriginal.length == 1
                && ( userRole !=userProfileManager.USER_TYPE.FAMILY_MEMBER
                    && userRole !=userProfileManager.USER_TYPE.ASSOCIATE )
                || (accountType==userProfileManager.INVITATION_TYPE.COMPANY
                && userRole==userProfileManager.USER_ROLE.PRIMARY) ) {
                showEdit = true;
            }
            return showEdit;
        };

        var loadStrings = function() {
            self.addressText1= strings.get('tdc_streetAddress1');
            self.addressText2= strings.get('tdc_streetAddress2');
            self.cityText= strings.get('tdc_city');
            self.stateText=strings.get('tdc_state');
            self.zipText=strings.get('tdc_zip');
            self.stError1=strings.get('tdc_streetaddress1error');
            self.autocompleteStError1=strings.get('tdc_autocompletestreetaddress1error');
            self.cityError=strings.get('tdc_cityerror');
            self.stateError=strings.get('tdc_stateerror');
            self.zipError=strings.get('tdc_ziperror');
            self.zipLengthError=strings.get('tdc_zipLengthError');
            self.blockedPostalCodeError=strings.get('tdc_blockedPostalCodeError');

            self.addressTranslations={
                'marketSelectHK': strings.get('tdc_marketSelectHK'),
                'marketSelectMO': strings.get('tdc_marketSelectMO'),
                'address1': self.addressText1,
                'address2': self.addressText2,
                'city': self.cityText,
                'state': self.stateText,
                'zipcode': self.zipText,
                'stError1': self.stError1,
                'cityError': self.cityError,
                'stateError': self.stateError,
                'zipLengthError': self.zipLengthError,
                'blockedPostalCodeError': self.blockedPostalCodeError,
                'zipError': self.zipError,
                'autocompleteStError1': self.autocompleteStError1,
            };
            model.taxIdTranslations = {
                taxIdLabel: strings.get('tdc_primaryBusinessTaxId'),
                taxIdErrorMessage: strings.get('tdc_primaryBusinessTaxIdErrorMessage'),
                taxIdRequiredErrorMessage: strings.get('tdc_primaryBusinessTaxIdRequiredErrorMessage'),
                hasTaxIdQuestion: strings.get('tdc_hasTaxIdQuestion'),
                confirmTaxIdPossession: strings.get('tdc_confirmTaxIdPossession'),
                denyTaxIdPossession: strings.get('tdc_denyTaxIdPossession'),
                taxIdSubmissionWarning: strings.get('tdc_taxIdSubmissionWarning'),
                agreeToObtainTaxId: strings.get('tdc_agreeToObtainTaxId'),
                emailToObtainTaxId: strings.get('tdc_emailToObtainTaxId')
            };
        };

        // Loads the configurations required for the business tax id form
        var loadBusinessTaxIdConfigs = function() {
            // Tax ID Properties
            model.taxIdConfigs = businessTaxIdConfigsFactory.getTaxIdConfigs(countryCode);
            model.hasTaxIdTooltip = accountConfigManager.site.hasBusinessTaxIdTooltip;
            if (model.hasTaxIdTooltip) {
                model.taxIdTranslations.whatIsTaxIdLink = strings.get('tdc_whatIsPrimaryBusinessTaxIdLink');
                model.taxIdTranslations.whatIsTaxIdMessage = strings.get('tdc_whatIsPrimaryBusinessTaxId');
            }
            model.taxIdValidator = businessTaxIdValidationFactory.getValidationUtil(countryCode);
            // If configs has a format for tax id, do not allow maxLength
            // MaxLength conflicts with ui-mask and will not allow you to enter characters
            if (model.taxIdConfigs.format) {
                model.taxIdMaxLength = '';
            } else {
                model.taxIdMaxLength = model.taxIdConfigs.maxLength;
            }
            model.taxIdFormatter = businessTaxIdFormatterFactory.getTaxIdFormatter(countryCode);
            model.taxId = '';
            model.businessTaxId = '';
            model.taxIdDisplay = [];

            model.taxIdUtils = businessTaxIdUtilsFactory.getBusinessTaxIdUtils(countryCode);
        };

        var setAccountTypeDisplay = function(accountType) {
            var accountDisplay;
            if (accountType === 'INDIVIDUAL') {
                accountDisplay = strings.get('tdc_individual');
            }
            if (accountType === 'COMPANY') {
                accountDisplay = strings.get('tdc_company');
            }
            return accountDisplay;
        };

        var loadBusinessDetails = function() {
            return businessService.loadDetails(model.userType).then(function(newAccountData) {
                var sponsor;
                if (newAccountData.sponsor.name) {
                    sponsor = new Sponsor(newAccountData.sponsor);
                }

                if (newAccountData.account) {
                    var account = new Account(newAccountData.account);
                    var legacyAccount = new LegacyAccountAdaptor(account, sponsor);
                    var data = {};

                    data.account = legacyAccount;

                    // overview processing
                    model.accountOriginal = data.account.header;
                    if (model.accountOriginal && model.accountOriginal.taxIDs.length > 0) {
                        model.accountOriginal.taxIDs.forEach(function(item) {
                            if (model.taxIdConfigs.fieldInSAP === item.type) {
                                model.taxId = item.value;
                                model.taxIdDisplay.push(model.taxIdFormatter.maskTaxId(item.value));
                            }
                        });
                        if (model.taxIdDisplay.length <=0 ) {
                            model.showEditbutton = true;
                        }
                    } else {
                        model.showEditbutton = true;
                    }

                    model.contactOriginal = data.account.contactInfo;
                    model.addressOriginal = data.account.address;
                    model.userdataOriginal = data.userdata;
                    model.userRole = model.userInfo.userRole;
                    model.accountType = data.account.header.accountType;
                    model.accountTypeDisplay = setAccountTypeDisplay(model.accountType);
                    model.profileUserInfo = data.profileUserInfo;
                    // model.contactPreference = account.preferences;

                    if (model.accountType == 'COMPANY') {
                        model.businessName = newAccountData.account.names.local;
                        model.businessTaxId = newAccountData.account.legalIDs[0].value;
                    };

                    newAccountData.account.persons.forEach(function(item, index, arr) {
                        if (item.preferences) {
                            model.contactPreference = item.preferences;
                        }
                    });


                    if (model.addressOriginal) {
                        if (model.accountType === 'COMPANY') {
                            model.addressOriginal = addressFormatter.formatFromService(account.addresses.local);
                        } else {
                            model.addressOriginal = addressFormatter.formatFromService(data.account.address);
                        }
                        model.displayAddress = addressFormatter.displayForProfile(model.addressOriginal);
                    }


                    if (newAccountData.account.persons) {
                        model.persons = newAccountData.account.persons;

                        var setUserPreferences = function(account) {
                            if (account.preferences) {
                                if (account.preferences.contactPreference == null
                                    || account.preferences.contactPreference == undefined
                                    || account.preferences.contactPreference == '') {
                                    account.preferences.contactPreference = emailLabel;
                                }
                                if (account.preferences.acceptMarketingEmail) {
                                    model.contactPreference.userPreferences = account.preferences.acceptMarketingSMS
                                        ? emailLabel + ', ' + textLabel : emailLabel;
                                } else {
                                    model.contactPreference.userPreferences = account.preferences.acceptMarketingSMS
                                        ? textLabel : notSpecifiedLabel;
                                }
                            }
                        };

                        setUserPreferences(newAccountData.account);

                        var setLanguagePreference = function(account) {
                            if (account.preferredLanguage) {
                                if (model.languageList && model.languageList.length > 0) {
                                    var langPref = account.preferredLanguage.toLowerCase();
                                    var language = model.languageList.filter(function(languageFromList) {
                                        return languageFromList.code == langPref;
                                    });

                                    if (language.length == 0) {
                                        language = model.languageList.filter(function(languageFromList) {
                                            return languageFromList.code == 'en';
                                        });
                                    }
                                    model.originalLanguage = language[0];
                                    model.contactPreference.languagePreferences = language[0].name;
                                    model.contactPreference.language = language[0];
                                }
                            }
                        };

                        setLanguagePreference(newAccountData.account);

                        var setContactPreferences = function(account) {
                            if (account.preferences) {
                                if (account.preferences.acceptMarketingEmail == null
                                    || account.preferences.acceptMarketingEmail == undefined
                                    || account.preferences.acceptMarketingEmail == '') {
                                    account.preferences.acceptMarketingEmail = false;
                                }
                                if (account.preferences.acceptMarketingEmail) {
                                    model.contactPreference.marketingEmail = true;
                                    model.contactPreference.emailIsOpted = true;
                                    model.originalEmailIsOpted = true;
                                } else {
                                    model.contactPreference.marketingEmail = false;
                                    model.contactPreference.emailIsOpted = false;
                                    model.originalEmailIsOpted = false;
                                }
                                updateEmailPreferenceAttribute(model.contactPreference.emailIsOpted);
                                if (account.preferences.acceptMarketingSMS) {
                                    model.contactPreference.textIsOpted = true;
                                    model.originalTextIsOpted = true;
                                } else {
                                    model.contactPreference.textIsOpted = false;
                                    model.originalTextIsOpted = false;
                                }
                                updateTextPreferenceAttribute(model.contactPreference.textIsOpted);
                            }
                        };

                        setContactPreferences(newAccountData.account);
                    }

                    var promise = businessService.profileHeaderInfo();
                    promise.then(function(data) {
                        if (data.person) {
                            loadHeaderDetails(data.person);
                        }
                        self.accSettingsVisible = true;
                    });

                    // This service is using Atlas. We should only use this for US, CA, and maybe AU?
                    // Everyone else should use the new account endpoint.
                    var distributorPaymentDetails;
                    if (countryCode == 'US' || countryCode == 'CA' || countryCode == 'AU' || countryCode == 'NZ') {
                        distributorPaymentDetails = businessService.getDistributorInfoPayment();
                        distributorPaymentDetails.then(function(response) {
                            if (response.status == 200) {
                                model.bankingOriginal = JSON.parse(JSON.stringify(response.data));
                                model.bankingOriginal.accountName = response.data.registeredName;

                                if (countryCode == 'US') {
                                    model.bankingOriginal.routingNumber = response.data.routingNumber;
                                    model.bankingOriginal.accountNumber = response.data.accountNumber;
                                    if (model.bankingOriginal.routingNumber || model.bankingOriginal.accountNumber) {
                                        model.bankInfoExist = true;
                                    }
                                } else if (countryCode == 'CA') {
                                    model.bankingOriginal.bankAccNum = response.data.accountNumber;
                                    if (undefined != response.data.bank) {
                                        model.bankingOriginal.bankName = response.data.bank.number;
                                        model.bankingOriginal.bankNameTitle = response.data.bank.name;
                                        model.bankingOriginal.bankbranchNumber = response.data.bank.branches[0].number;
                                    } else {
                                        model.bankingOriginal.bankName = undefined;
                                        model.bankingOriginal.bankNameTitle = undefined;
                                        model.bankingOriginal.bankbranchNumber = undefined;
                                    }
                                    if (model.bankingOriginal.bankbranchNumber || model.bankingOriginal.bankAccNum) {
                                        model.bankInfoExist = true;
                                    }
                                } else if (countryCode == 'AU') {
                                    model.bankingOriginal.bsbNum = response.data.routingNumber;
                                    model.bankingOriginal.accountNumber = response.data.accountNumber;
                                    if (model.bankingOriginal.bsbNum || model.bankingOriginal.accountNumber) {
                                        model.bankInfoExist = true;
                                    }
                                } else if (countryCode == 'NZ') {
                                    model.bankingOriginal.bankAccNum = response.data.accountNumber;
                                    if (undefined != response.data.bank) {
                                        model.bankingOriginal.bankName = response.data.bank.number;
                                        model.bankingOriginal.bankNameTitle = response.data.bank.name;
                                        model.bankingOriginal.bankbranchNumber = response.data.bank.branches[0].number;
                                    } else {
                                        model.bankingOriginal.bankName = undefined;
                                    }
                                    if (model.bankingOriginal.bankbranchNumber || model.bankingOriginal.bankAccNum) {
                                        model.bankInfoExist = true;
                                    }
                                }
                                angular.extend(model.banking, model.bankingOriginal);
                            }
                        });
                    } else { // Call the new Account endpoint.
                        distributorPaymentDetails = businessService.getAccountInfo();
                        distributorPaymentDetails.then(function(response) {
                            if (response.status == 200) {
                                model.bankingOriginal.accountName = response.data.account.names.local;
                                var bankAccounts = response.data.account.bankAccounts;
                                if (bankAccounts && (bankAccounts.constructor === Array)
                                    && (bankAccounts.length > 0)) {
                                    model.bankingOriginal.accountType = response.data.account
                                        .bankAccounts[0].accountType;
                                    model.bankingOriginal.bankName = response.data.account
                                        .bankAccounts[0].bankName;
                                    model.bankingOriginal.accountNumber = response.data.account
                                        .bankAccounts[0].accountNumber;
                                    model.bankingOriginal.routingNumber = response.data.account
                                        .bankAccounts[0].routingNumber;
                                    model.bankingOriginal.ibanNumber = response.data.account
                                        .bankAccounts[0].IBAN;
                                }

                                if (model.bankingOriginal.routingNumber || model.bankingOriginal.accountNumber) {
                                    model.bankInfoExist = true;
                                }

                                angular.extend(model.banking, model.bankingOriginal);
                            }
                        });
                    }

                    model.leftTabsList = [{
                        'id': 0,
                        'name': 'account-details',
                        'label': strings.get('tdc_accdltheader'),
                        'show': true
                    }, {
                        'id': 1,
                        'name': 'contact-details',
                        'label': strings.get('tdc_contactdetailstext'),
                        'show': true
                    }, {
                        'id': 2,
                        'name': 'business-address',
                        'label': strings.get('tdc_address'),
                        'show': true
                    }, {
                        'id': 3,
                        'name': 'direct-deposit',
                        'label': strings.get('tdc_bankinfoheader'),
                        'show': true
                    }, {
                        'id': 4,
                        'name': 'business-associates',
                        'label': strings.get('tdc_bussAssociateLabel'),
                        'show': true
                    }, {
                        'id': 5,
                        'name': 'communication-preference',
                        'label': strings.get('tdc_communicationPreferencestext'),
                        'show': true
                    }];
                    if (accountConfigManager && accountConfigManager.site.hideAssociate) {
                        model.leftTabsList[4].show = false;
                    }
                    if (model.hideDirectDeposit) {
                        if (model.leftTabsList[3].name === 'direct-deposit') {
                            model.leftTabsList[3].show = false;
                        }
                    }
                    angular.extend(model.account, model.accountOriginal);
                    // angular.extend(model.contact, model.contactOriginal);
                    model.contact = angular.copy(model.contactOriginal);
                    angular.extend(model.address, model.addressOriginal);
                    angular.extend(model.userdata, model.userdataOriginal);

                    if (model.accountType !== 'Business' || (model.userRole == 'Associate'
                            && model.accountType == 'Business')) {
                        model.associatesListOriginal = data.account.persons ? data.account.persons : null;
                    } else {
                        model.associatesListOriginal = angular.copy(model.associatesList);
                    }

                    var myPersonId = getPersonId();
                    if (newAccountData.account.persons) {
                        newAccountData.account.persons.forEach(function(person) {
                            if (myPersonId !== person.id) {
                                var tempPhone = '';
                                if (person.phoneNumbers && (person.phoneNumbers.length > 0)) {
                                    tempPhone = person.phoneNumbers[0];
                                }

                                var status = person.termsAndConditions.valid ? 'verified' : 'sent';

                                var firstName;
                                var lastName;
                                if (person.names && person.names.local) {
                                    firstName = person.names.local.given;
                                    lastName = person.names.local.family;
                                }

                                model.associatesList.push({
                                    'id': model.associatesList.length - 1,
                                    'firstName': firstName,
                                    'lastName': lastName,
                                    'image': person.profileThumbnailUrl,
                                    'accountstatus': 'NOT_POPULATED',
                                    'invitationUuId': 'NOT_POPULATED',
                                    'contactpreference': {
                                        'phone': tempPhone,
                                        'email': (person.email != null) ? person.email : '',
                                        'contactpref': ''
                                    },
                                    'inviteStatus': [{
                                        'id': 101,
                                        'status': true,
                                        'name': status,
                                        'label': ''
                                    }]
                                });
                            }
                        });
                    }

                    // mobile phone number
                    if (model.contact.phoneList) {
                        model.contact.phoneList.forEach(function(item, index, arr) {
                            if (item.type == 'MOBILEPHONE') {
                                model.contact.mobilePhoneInput = item.value;
                                model.contact.phoneCode = item.country;

                                model.contact.mobilePhoneInput = PhoneNumberFormatter
                                    .getPhoneSaveFormat(model.contact.phoneCode, model.contact.mobilePhoneInput);
                                model.contact.phoneDisplay = PhoneNumberFormatter
                                    .getPhoneDisplayFormat(model.contact.phoneCode, model.contact.mobilePhoneInput);

                                model.contactOriginal.phone = model.contact.mobilePhoneInput;
                                model.contactOriginal.phoneCode = model.contact.phoneCode;
                            }
                        });
                    }
                    model.contactOriginal = angular.copy(model.contact);
                }
                self.showPref = true;
                if (window.location.search.length > 0) {
                    var url = new URL(window.location.href);
                    model.currentTab = url.searchParams.get('loadTab');
                    if (model.currentTab !=undefined && model.currentTab!='' && model.currentTab!=null) {
                        model.loadTab(model.currentTab);
                    }
                } else {
                    model.currentTab = model.leftTabsList[0].name;
                }
            });
        };

        var loadHeaderDetails = function(data) {
            model.headerInfo.firstName = data.names.local.given;
            model.headerInfo.lastName = data.names.local.family;
            model.headerInfo.fullName = model.headerInfo.firstName +' '+ model.headerInfo.lastName;

            if (data.preferredName != '' && data.preferredName != null && data.preferredName != 'undefined') {
                model.isPreferredNamePresent = true;
                model.headerInfo.preferredName = data.preferredName;
                model.headerInfo.fullName = model.headerInfo.preferredName;
            }

            model.headerInfo.thumbnailURL = $rootScope.accImage = data.profileThumbnailUrl;

            var authoredProfileImageRef = userProfileManager.getProfileImageReference();

            if (authoredProfileImageRef != null && authoredProfileImageRef != '') {
                model.headerInfo.defaultthumbnailURL = authoredProfileImageRef;
            } else {
                model.headerInfo.defaultthumbnailURL = '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/' +
                    'css/ic-profile-copy-2.png';
            }

            if (data.profileImageUrl) {
                model.headerInfo.profilePictureUrl = data.profileImageUrl;
            } else {
                var origImageUrl = model.headerInfo.thumbnailURL;
                if (origImageUrl != undefined && origImageUrl.indexOf('gigya.com') > -1) {
                    origImageUrl = origImageUrl.replace('thumbnail', 'orig');
                    model.headerInfo.profilePictureUrl = origImageUrl;
                } else {
                    model.headerInfo.profilePictureUrl = data.profileThumbnailUrl;
                }
            }
        };

        model.checkLength = function(flag) {
            if (flag == 'r') {
                if (model.banking.routingNumber) {
                    if (model.banking.routingNumber.length != 9) {
                        model.invalidRoutingLength = true;
                    } else {
                        model.invalidRoutingLength = false;
                    }
                }
            }
            if (flag == 'bsb') {
                if (model.banking.bsbNum) {
                    if (model.banking.bsbNum.length != 6) {
                        model.invalidbsbLength = true;
                        form.bsbnum.$error.invalidbsbLength = true;
                    } else {
                        model.invalidbsbLength = false;
                        form.bsbnum.$error.invalidbsbLength = false;
                    }
                }
            }
            if (flag == 'abn') {
                if (model.abnNumber) {
                    if (model.abnNumber.length == 11 || model.abnNumber.length == 0) {
                        angular.element('#abnNumber').removeClass('ng-invalid');
                        model.invalidabnLength = false;
                    } else {
                        angular.element('#abnNumber').addClass('ng-invalid');
                        model.invalidabnLength = true;
                    }
                } else {
                    angular.element('#abnNumber').removeClass('ng-invalid');
                    model.invalidabnLength = false;
                }
            }
            if (flag == 'gst') {
                if (model.gstNumber) {
                    if (model.gstNumber.length == 9 || model.gstNumber.length == 0) {
                        angular.element('#gstNumber').removeClass('ng-invalid');
                        model.invalidgstLength = false;
                    } else {
                        angular.element('#gstNumber').addClass('ng-invalid');
                        model.invalidgstLength = true;
                    }
                } else {
                    angular.element('#gstNumber').addClass('ng-invalid');
                    model.invalidgstLength = true;
                }
            }
        };

        model.checkIbanValidity = function(currentForm) {
            var isFieldValid;
            var ibanValue;
            if (currentForm) {
                if (currentForm.ibanNumber) {}
                //   model.paymentForm.ibanNumber.$setValidity('fieldInvalid', true);
                ibanValue=currentForm.ibanNumber.$viewValue.replace(/[^a-zA-Z0-9]/g, '').slice(2);
                isFieldValid = ibanValue && ibanValue.length == lenIban;
                if (isFieldValid) {
                    var flag = validIban(countryCode+ibanValue);
                    currentForm.ibanNumber.$setValidity('invalidIbanNumber', flag);
                } else {
                    currentForm.ibanNumber.$setValidity('invalidIbanNumber', isFieldValid);
                }
            }
        };

        var validIban = function(ibanNumber) {
            ibanNumber = ibanNumber.toUpperCase();
            var newIban = ibanNumber.substr(4, ibanNumber.length)+ibanNumber.substr(0, 4);
            var checkMod = '';
            for (var i = 0; i < newIban.length; ++i) {
                if (newIban.charAt(i).match(/[A-Z]/)) {
                    checkMod = (checkMod.toString() + (newIban.charCodeAt(i)-55).toString());
                } else {
                    checkMod = checkMod.toString() + newIban.charAt(i).toString();
                }
                checkMod = parseInt(checkMod) % 97;
            }
            return checkMod == 1;
        };


        var pageURL = $window.location.href;

        if (pageURL.search('primary') != -1) {
            model.check = true;
        } else {
            model.check = false;
        }

        model.inlineEditForAddress = function() {
            model.showAddressForm = true;
            model.showCheckBox = true;
        };

        model.loadTab = function(currentTab) {
            if (currentTab !== 'contact-details' && model.showContactForm === true) {
                if (self.contactform) {
                    model.cancelContact(self.contactform);
                }
            }
            if (currentTab !== 'business-address' && model.showAddressForm === true) {
                model.cancelAddress();
            }
            if (currentTab !== 'direct-deposit' && model.showBankingForm === true) {
                if (self.bankingform) {
                    model.cancelBanking(self.bankingform);
                }
            }

            model.currentTab = currentTab;
        };

        model.showContactFormFunc = function() {
            model.showContactForm = true;
            self.credentials.isSubmitted = false;

            model.contact.mobilePhoneInput = PhoneNumberFormatter
                .getPhoneSaveFormat(model.contact.phoneCode, model.contact.mobilePhoneInput);
            model.contactOriginal.phone = model.contact.mobilePhoneInput;
            model.contactOriginal.phoneCode = model.contact.phoneCode;
        };

        model.saveAccountDetails = function(isValid) {
            if (isValid && model.taxId) {
                var validTaxId = model.taxIdValidator.isValidTaxId(model.taxId);
                if (validTaxId) {
                    var taxIdData = {
                        type: model.taxIdConfigs.fieldInService,
                        value: model.taxId
                    };
                    var formattedTaxId = model.taxIdFormatter.formatToService(taxIdData);
                    var promise = businessService.setAccountDetails(formattedTaxId);
                    promise.then(function(status) {
                        if (status === 200 || status === 201) {
                            model.taxIdDisplay.push(model.taxIdFormatter.maskTaxId(model.taxId));
                            model.showAccountDetailsForm = false;
                            model.showEditbutton = false;
                            businessService.scrollToTop('.account-wrapper');
                        } else {
                            model.showAccountDetailsForm = true;
                            model.showEditbutton = true;
                        }
                    });
                }
            }
        };


        model.cancelAccountDetails = function(form) {
            model.showAccountDetailsForm = false;
            model.taxId = '';
            model.taxIdDisplay = [];
            form.$setUntouched();
            businessService.scrollToTop('.account-wrapper');
        };


        model.saveContact = function(isValid) {
            if (isValid && model.contact.mobilePhoneInput && model.contact.mobilePhoneInput != '') {
                model.contact.email = self.credentials.userEmailField;

                model.contact.phone = model.contact.mobilePhoneInput = PhoneNumberFormatter
                    .getPhoneSaveFormat(model.contact.phoneCode, model.contact.mobilePhoneInput);
                model.contact.phoneDisplay = PhoneNumberFormatter
                    .getPhoneDisplayFormat(model.contact.phoneCode, model.contact.mobilePhoneInput);

                var promise = businessService.setContactDetails(model.contact);
                promise.then(function(status) {
                    if (status == 200 || status == 201) {
                        model.contact.mobilePhoneInput = PhoneNumberFormatter
                            .getPhoneSaveFormat(model.contact.mobilePhoneCode, model.contact.mobilePhoneInput);
                        model.contactOriginal = angular.copy(model.contact);
                        model.showContactForm = false;
                    } else {
                        // TODO - error handling
                    }
                });
            }
            businessService.scrollToTop('.account-wrapper');
        };

        self.saveCommunicationPreference = function(isValid) {
            if (isValid) {
                self.isCommunicationReadOnly = true;

                var promise = businessService.saveCommunicationPreference(model.contactPreference,
                    strings.get('tdc_commemailtext'));
                promise.then(function(data) {
                    if (data == 200) {
                        model.originalEmailIsOpted = model.contactPreference.emailIsOpted;
                        model.originalTextIsOpted = model.contactPreference.textIsOpted;
                        if (model.contactPreference.emailIsOpted) {
                            model.contactPreference.userPreferences = model.contactPreference.textIsOpted
                                ? emailLabel + ', ' + textLabel : emailLabel;
                        } else {
                            model.contactPreference.userPreferences = model.contactPreference.textIsOpted
                                ? textLabel : notSpecifiedLabel;
                        }
                        model.contactPreference.languagePreferences = model.contactPreference.language.name;
                        model.contactPreference.languagePreferences1 = model.contactPreference.language.code;
                        if (model.contactPreference.emailIsOpted == undefined
                            || model.contactPreference.emailIsOpted == '') {
                            model.contactPreference.marketingEmail = false;
                        } else {
                            model.contactPreference.marketingEmail = true;
                        }
                        var commTab = '?loadTab=communication-preference';
                        if (model.contactPreference.languagePreferences.toUpperCase()
                            != model.originalLanguage.name.toUpperCase()) {
                            var newLanguage = model.contactPreference.languagePreferences1.toLowerCase();
                            var url = localeUtil.replaceUrlLocale(window.location.href, countryCode, newLanguage);

                            if (window.location.search.length > 0) {
                                $window.location.href = url;
                            } else {
                                $window.location.href = url.slice(0, url.lastIndexOf('#'))
                                    + commTab + url.slice(url.lastIndexOf('#'), url.length);
                            }
                        }
                    }
                });
            }
            businessService.scrollToTop('.comm-wrapper');
        };

        model.cancelCommunicationPreference = function() {
            model.contactPreference.language = model.originalLanguage;
            model.contactPreference.emailIsOpted = model.originalEmailIsOpted;
            updateEmailPreferenceAttribute(model.contactPreference.emailIsOpted);
            model.contactPreference.textIsOpted = model.originalTextIsOpted;
            updateTextPreferenceAttribute(model.contactPreference.textIsOpted);
        };

        model.getHtmlFromString = function(string) {
            return $sce.trustAsHtml(string);
        };

        model.executeInvite = function(invitationUuId) {
            var promise = businessService.invitationResend(invitationUuId);
            promise.then(function(data) {
                var msg = {
                    successMessage: strings.get('tdc_businessAssociateEmailResentSuccess')
                };
                // This will trigger the $on watch on page-level-msg controller in nuskin-mec-common.
                $rootScope.$emit('emailSuccessfullySent', msg);
            }, function(error) {
                var msg = {
                    errorMessage: strings.get('tdc_businessAssociateEmailResentError')
                };
                $rootScope.$emit('emailSentError', msg);
            });
        };

        model.cancelContact = function(form) {
            model.contact = angular.copy(model.contactOriginal);
            /* Number formatting was missing for Bussiness User Cancel Contact Details*/
            var mobileNumber = model.contactOriginal.phone;
            if (mobileNumber) {
                model.contact.phoneDisplay = PhoneNumberFormatter
                    .getPhoneDisplayFormat(model.contact.phoneCode, mobileNumber);
                self.credentials.userPhoneField = model.contactOriginal.phone;
            }
            self.credentials.userEmailField = model.contactOriginal.email;
            model.showContactForm = false;
            form.$setUntouched();
            form.$setPristine();
            businessService.scrollToTop('.account-wrapper');
        };

        model.saveAddress = function(isValid) {
            self.addressform.$submitted = true;
            if (!isValid) {
                return false;
            }

            if (model.sameAddressCheckbox) {
                model.contactAddress.sameAsContactAddrFlag = model.sameAddressCheckbox;
                var promise = businessService.setAddresstDetails(model.contactAddress);
                promise.then(function(data) {
                    angular.extend(model.addressOriginal, model.contactAddress);
                    angular.extend(model.address, model.contactAddress);
                    model.showAddressForm = false;
                });
            } else {
                self.checkIfValidAddress(isValid, model.isSameAddressCheckbox);
            }

            businessService.scrollToTop('.address-wrapper');
        };

        model.cancelAddress = function() {
            if (Object.keys(model.addressOriginal).length === 0 && model.addressOriginal.constructor === Object) {
                model.addressOriginal = {
                    city: '',
                    streetAddress: '',
                    streetAddress2: '',
                    zipcode: '',
                    state: '',
                    sameAddressCheckbox: ''
                };
                angular.extend(model.address);
                model.showAddressForm = false;
            } else {
                angular.extend(model.address, model.addressOriginal);
                model.showAddressForm = false;
            }
            businessService.scrollToTop('.address-wrapper');
            self.addressform.$setUntouched();
            self.addressform.$setPristine();
        };

        model.editAddress = function() {
            model.showAddressForm = true;
            model.enterAddress = angular.copy(model.address);
        };

        model.saveAddressOnSuccess = function(addressData) {
            model.address.streetAddress = addressData.addressLine1;
            model.address.streetAddress2 = addressData.addressLine2;
            model.address.city = addressData.city;
            model.address.state = addressData.state;
            model.address.zipcode = addressData.zip;
            model.address.country = countryCode;
            model.address.sameAsContactAddrFlag = model.sameAddressCheckbox;

            var promise = businessService.setAddresstDetails(model.address);
            promise.then(function(response) {
                if (response.status == 200 || response.status == 201) {
                    model.address = addressFormatter.formatFromService(response.data.account.addresses.local);
                    model.displayAddress = addressFormatter.displayForProfile(model.address);
                    angular.extend(model.addressOriginal, model.address);
                    model.showAddressForm = false;
                } else {
                    $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                }
            }).catch(function() {
                $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
            });
        };

        self.checkIfValidAddress = function(isValid, isSameAddressCheckbox) {
            self.isSaveButtonClicked = true;
            var checkIfIsValid = isSameAddressCheckbox ? true : isValid ? true : false;
            if (checkIfIsValid && !isSameAddressCheckbox) {
                self.isSaveForAddressClicked = true;

                self.addressJsonDataForModal = {
                    'addressLine1': model.address.streetAddress,
                    'addressLine2': model.address.streetAddress2,
                    'city': model.address.city,
                    'state': model.address.state,
                    'zip': model.address.zipcode


                };
                if (!addressConfigs.qasValidation) {
                    model.saveAddressOnSuccess(self.addressJsonDataForModal);
                } else {
                    qas.callQAS(self.addressJsonDataForModal, $rootScope.qasCallback, accountConfigManager);
                }
            }
        };

        $rootScope.qasCallback = function QAScalled(addresses) {
            self.addressList = [];
            self.suggestionsData = null;
            if (addresses instanceof Array && addresses.length != 0) {
                addresses.forEach(function(item) {
                    var tempAddress = {};
                    try {
                        if (null != item.addressText && undefined != item.addressText) {
                            var addressLines = item.addressText.split(',');
                            var cityStateZip = '';
                            if (addressLines.length == 3) {
                                tempAddress.addressLine1 = addressLines[0];
                                tempAddress.addressLine2 = addressLines[1];

                                cityStateZip = addressLines[2].trim();
                            }
                            if (addressLines.length == 2) {
                                tempAddress.addressLine1 = addressLines[0];
                                cityStateZip = addressLines[1].trim();
                            }

                            switch (countryCode) {
                            case 'CA':
                                tempAddress.zip = cityStateZip.substr(cityStateZip.length - 7);
                                var cityState = cityStateZip.substring(0, cityStateZip.length - 7);
                                tempAddress.state = cityState.substring(cityState.length - 2);
                                tempAddress.city = cityState.substring(0, cityState.length - 3);
                                break;
                            case 'AU':
                                tempAddress.zip = cityStateZip.substr(cityStateZip.length - 4);
                                cityStateZip = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.zip));
                                var cityStateArray = cityStateZip.split(/[\s,]+/);
                                if (cityStateArray.length > 0) {
                                    tempAddress.state = cityStateArray[cityStateArray.length - 1];
                                }
                                tempAddress.city = cityStateZip.substring(0, cityStateZip.lastIndexOf(' '));
                                break;
                            case 'NZ':
                                tempAddress.zip = cityStateZip.substr(cityStateZip.length - 4);
                                cityStateZip = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.zip));
                                var cityStateArray = cityStateZip.split(/[\s,]+/);
                                if (cityStateArray.length > 0) {
                                    tempAddress.state = cityStateArray[cityStateArray.length - 1];
                                }
                                tempAddress.city = cityStateZip.substring(0, cityStateZip.lastIndexOf(' '));
                                break;
                            default:
                                tempAddress.zip = cityStateZip.trim().match('([0-9]+)(-[0-9]+)?')[0];
                                cityStateZip = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.zip));
                                tempAddress.state = cityStateZip.substring(cityStateZip.length - 2);
                                tempAddress.city = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.state));
                                break;
                            }

                            self.addressList.push(tempAddress);
                        }
                    } catch (err) {}
                });
                self.invalidAddress = false;
                self.isSaveForAddressClicked = true;
                self.suggestionsData = self.addressList;
                modalPopupInstance(addressValidationModalTemplate, 'addressVerification',
                    'app-modal-window address-verification-popup');
            } else if (addresses == 'InvalidAddress') {
                self.invalidAddress = true;
                self.isSaveForAddressClicked = true;
                modalPopupInstance(addressValidationModalTemplate, 'addressVerification',
                    'app-modal-window address-verification-popup');
            } else if (addresses && addresses instanceof Object) {
                if (addresses.zip != undefined) {
                    self.addressJsonDataForModal.addressLine1 = addresses.lineone
                        ? addresses.lineone.toUpperCase() : '';
                    self.addressJsonDataForModal.addressLine2 = addresses.linetwo
                    && addresses.linetwo != 'Undefined' ? addresses.linetwo.toUpperCase() : '';
                    self.addressJsonDataForModal.city = addresses.city ? addresses.city.toUpperCase() : '';
                    self.addressJsonDataForModal.state = addresses.state ? addresses.state.toUpperCase() : '';
                    self.addressJsonDataForModal.zip = addresses.zip ? addresses.zip : '';
                    model.saveAddressOnSuccess(self.addressJsonDataForModal);
                }
            }
        };


        model.addressValidationController = function($uibModalInstance, $scope) {
            var modalSelf = this;
            modalSelf.model = {};
            modalSelf.model.addressList = self.addressList;
            modalSelf.addressData = self.addressData;
            modalSelf.suggestionsData = self.suggestionsData;
            modalSelf.invalidAddress = self.invalidAddress;

            modalSelf.ok = function() {
                $uibModalInstance.close();
            };

            modalSelf.cancel = function() {
                $uibModalInstance.dismiss();
            };

            modalSelf.goBackAndEdit = function() {
                modalSelf.cancel();
            };

            modalSelf.goWithSelectedAddress = function(isValid, selectedObject) {
                if (isValid) {
                    modalSelf.useEnteredAddress(selectedObject);
                }
            };

            modalSelf.useEnteredAddress = function(addressDataObj) {
                modalSelf.finalAddressData = addressDataObj ? addressDataObj : self.addressJsonDataForModal;
                model.saveAddressOnSuccess(modalSelf.finalAddressData);
                modalSelf.ok();
            };
        };


        model.hideRoutingErrorMessage = function(form) {
            model.invalidRoutingNumber = false;
        };

        model.saveBanking = function(isValid) {
            if (!model.banking.acceptedDirectDepositPolicy) {
                isValid = false;
            }

            if (!isValid) {
                model.bankFormInfo.isSubmitted = true;
                return false;
            }


            if (countryCode == 'US' || countryCode == 'CA') {
                var distributorEligible = bankService.isDistributorEligible();
                distributorEligible.then(function(response) {
                    if (response.data.eligible) {
                        model.submitBankDetails(model.banking);
                    } else {
                        var errorComp = angular.element.find('#distributornoteligiblemsg')[0];
                        errorComp.style.display = 'block';
                    }
                });
            } else {
                if (model.banking.IBAN) {
                    model.banking.IBAN = model.banking.IBAN.replace(/[^a-zA-Z0-9]/g, '');
                }
                model.submitBankDetails(model.banking);
            }

            businessService.scrollToTop('.bank-wrapper');
        };

        model.submitBankDetails = function(data) {
            data = bankService.formatPayload(data);

            var promise = bankService.saveBankDetails(data);
            promise.then(function(response) {
                if (response.status == 200) {
                    model.showBankingForm = false;
                    model.bankFormInfo.isCompletePayment = true;
                    model.bankFormInfo.isPaymentDisabled = true;
                    model.bankFormInfo.isSubmitted = true;
                    model.bankingOriginal = JSON.parse(JSON.stringify(response.data));
                    model.bankingOriginal.accountName = response.data.registeredName;
                    model.bankingOriginal.bsbNum = response.data.routingNumber;

                    if (response.bankAccounts) {
                        model.bankingOriginal.ibanNumber = response.bankAccounts.IBAN;
                    }

                    if (undefined != response.data.bank) {
                        model.bankingOriginal.bankName = response.data.bank.number;
                        model.bankingOriginal.bankbranchNumber = response.data.bank.branches[0].name;
                    }
                    if (model.bankList) {
                        model.bankingOriginal.bankNameTitle = model.bankList.filter(function(item) {
                            return item.number == response.data.bank.number;
                        })[0].name;
                    }
                    if (model.bankingOriginal.routingNumber) {
                        model.bankingOriginal.routingNumber = '*****' + model.bankingOriginal
                            .routingNumber.substr(model.bankingOriginal.routingNumber.length - 4);
                    }
                    if (model.bankingOriginal.accountNumber) {
                        model.bankingOriginal.accountNumber = '*****' + model.bankingOriginal
                            .accountNumber.substr(model.bankingOriginal.accountNumber.length - 4);
                    }
                    if (model.bankingOriginal.bankbranchNumber) {
                        model.bankingOriginal.bankbranchNumber = '*****' + model.bankingOriginal
                            .bankbranchNumber.substr(model.bankingOriginal.bankbranchNumber.length - 4);
                    }
                    if (model.bankingOriginal.ibanNumber) {
                        model.bankingOriginal.ibanNumber = '*****' + model.bankingOriginal
                            .ibanNumber.substr(model.bankingOriginal.ibanNumber.length - 4);
                    }
                    model.bankInfoExist=true;
                }
            }).catch(function(err) {
                if (err.status === 400) {
                    model.bankFormInfo.invalidRoutingNumber = true;
                } else {
                    var errorComp = angular.element.find('#servicedownmsg')[0];
                    errorComp.style.display = 'block';
                }
            });
        };

        /*  var extractAccNumRoutingNum = function(ibanNumber, countryCode, ibanLength) {
            var accNumber;
            var routingNum;
            switch (countryCode) {
            case 'GB': // UK
                accNumber = ibanNumber.substr(12, ibanLength+1);
                routingNum = ibanNumber.substr(6, 6); // starting from 6th character to nect 6 chareacter
                break;
            case 'ES': // spain
                accNumber = ibanNumber.substr(12, ibanLength+1);
                routingNum = ibanNumber.substr(4, 4);
                break;
            case 'PF': // french polynesia
                accNumber = ibanNumber.substr(12, ibanLength-1);
                routingNum = ibanNumber.substr(5, 5);
                break;
            case 'FR': // France
                accNumber = ibanNumber.substr(12, ibanLength-1);
                routingNum = ibanNumber.substr(5, 5);
                break;
            }

            return [accNumber, routingNum];
        };*/

        self.directDepositCheckbox = function() {
            self.isDirectDepositCheckboxTouched = true;
        };

        model.editBankingForm = function(currentForm) {
            self.bankingform = currentForm;
            self.bankingform.$setUntouched();
            self.bankingform.$setPristine();
            model.showBankingForm = true;
        };

        model.cancelBanking = function(currentForm) {
            self.bankingform = currentForm;
            self.bankingform.$setUntouched();
            self.bankingform.$setPristine();
            model.banking = JSON.parse(JSON.stringify(model.bankingOriginal));
            model.banking.directDeposit = false;
            self.model.banking.bsbNum = null;
            model.showBankingForm = self.isDirectDepositCheckboxTouched = self.bankingSubmitPressed = false;
            model.bankFormInfo.isSubmitted = false;
            document.getElementById('directDepositCheckbox').removeAttribute('checked');
            businessService.scrollToTop('.bank-wrapper');
        };
        model.clickCheckAddress = function() {
            if (model.address.sameAddressCheckbox == false) {
                angular.extend(model.address, model.addressOriginal);
                model.address.streetAddress = '';
                model.address.streetAddress2 = '';
                model.address.city = '';
                model.address.state = '';
                model.address.zipcode = '';
                model.checkboxValue = true;
            } else {
                angular.extend(model.address, model.addressOriginal);
                model.checkboxValue = false;
            }
        };

        model.saveAccEdit = function() {
            // TODO
            if (self.popupform.$invalid) {
                return;
            } else {
                angular.element(accountEdit).modal('hide');
            }

            var gigyaCallPromise = businessService.setHeaderInfoGigya(model.userdata);
            var muleSoftCallPromise = businessService.setHeaderInfoMuleSoft(model.userdata);
            gigyaCallPromise.then(function(status) {
                if (status == 'OK') {} else {
                    model.cancelAccEdit();
                }
            });
            muleSoftCallPromise.then(function(status) {
                if (status == 200) {} else {
                    model.cancelAccEdit();
                }
            });
            businessService.scrollToTop('#accountEdit');
        };

        model.cancelAccEdit = function() {
        };

        model.checkMail = function() {
            var emailInput = self.form.contactform.email.$modelValue;
            // eslint-disable-next-line max-len
            var patternForemail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var emailvalidflag = patternForemail.test(emailInput);

            if (emailInput === undefined || emailInput === '') {
                model.emailRequired = true;
                model.emailInvalid = false;
                return;
            }

            if (emailInput !== undefined) {
                if (emailInput !== '') {
                    model.emailInvalid = !emailvalidflag;
                    model.emailRequired = false;
                }
            }
        };

        self.addAssociate = function(associateObj) {
            model.selectedAssociate = associateObj;
            modalPopupInstance(addAssociateModalTemplate, 'addAssociate',
                'app-modal-window add-associate-popup business-section-popup');
        };

        self.removeAssociate = function(associateObj, domAssociateId) {
            angular.forEach(model.associatesList, function(value, key) {
                if (associateObj == value) {
                    model.associatesList.splice(key, 1);
                    self.deleteAssociateObj = value;
                }
            });
        };
        /* This Field Validates the Tax ID uniqueness in Hybris and ATLAS*/
        self.goToUrl = function(dest) {
            if (dest) {
                $window.location = commonUtil.constructFullUrl(dest);
            }
        };
        model.validateTaxId = function(tax1, tax2) {
            if (tax1.$valid && tax2.$valid) {
                model.validateSSN();
            }
        };

        model.validateSSN = function() {
            var taxID = model.businessDistributor.taxId1 + model.businessDistributor.taxId2;
            model.duplicateTaxID = false;
            model.duplicateTaxIDActive = false;
            model.duplicateTaxIDInActive = false;

            var promise = businessService.validateSSN(taxID);
            promise.then(function successCallback(response) {
                var data = response.data;
                if (data.isAvailableTaxId == false) {
                    if (data.isActive == true) {
                        model.duplicateTaxIDActive = true;
                    } else {
                        model.duplicateTaxIDInActive = true;
                    }
                } else {
                    model.duplicateTaxID = false;
                }
            }, function errorCallback(response) {
                model.duplicateTaxID = true;
            });
        };

        model.agreeToTerms = function(isValid) {
            if ((!isValid) || model.duplicateTaxID || model.duplicateTaxIDActive || model.duplicateTaxIDInActive) {
                return false;
            }

            modalPopupInstance(termsModalTemplate, 'termsAndConditions',
                'app-modal-window terms-conditions-modal-body');
        };

        self.saveEditAssociates = function() {
            var promise = businessService.removeAssociate(self.deleteAssociateObj);
            promise.then(function(data) {});
            angular.copy(model.associatesList, model.associatesListOriginal);
        };

        self.cancelEditAssociate = function() {
            angular.copy(model.associatesListOriginal, model.associatesList);
            self.checkBusinessAccountType();
        };


        self.editProfile = function() {
            modalPopupInstance(fileUploadModalTemplate, 'editProfile',
                'app-modal-window file-upload-popup business-section-popup', true);
        };

        var modalPopupInstance = function(modalTemplateVariable,
            controller,
            windowClass,
            isCropModal,
            croppedImg,
            editProfileCachedData) {
            if (controller == 'addAssociate') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
                        var modalSelf = this;
                        modalSelf.model = {};
                        modalSelf.model.credentials = {};
                        modalSelf.model.listSeeMore = self.listSeeMore;
                        modalSelf.model.mobilephone = '';
                        modalSelf.emailValue = 0;
                        modalSelf.mobilePhoneValue = 1;
                        modalSelf.model.isDuplicateId = false;

                        modalSelf.ok = function() {
                            $uibModalInstance.close();
                        };

                        modalSelf.cancel = function() {
                            $uibModalInstance.dismiss();
                        };

                        modalSelf.executeInvite = function() {
                            // To Be Done By AEM people
                        };

                        $rootScope.$on('eventIsDuplicate', function(data) {
                            $scope.isRequiredError = data;
                            modalSelf.model.isDuplicateId = false;
                            $scope.$apply();
                        });

                        $scope.$on('$locationChangeStart', function($event) {
                            $uibModalStack.dismissAll();
                        });

                        modalSelf.sendInvite = function(isValid) {
                            angular.element('form[name="form.formInviteSection"] email-phone input')
                                .addClass('ng-touched');
                            var errorComp = angular.element.find('#verifyUsernameAvailableBusiness')[0];

                            if (modalSelf.credentials.userEmailField) {
                                gigya.accounts.isAvailableLoginID({
                                    loginID: modalSelf.credentials.userEmailField,
                                    callback: function(data) {
                                        if (!data.isAvailable) {
                                            errorComp.style.display = 'block';
                                            modalSelf.model.isDuplicateId = true;
                                            $scope.$apply();
                                        } else {
                                            if (isValid) {
                                                var memberinfo = {
                                                    'firstname': modalSelf.model.firstname,
                                                    'lastname': modalSelf.model.lastname,
                                                    'mobilephone': modalSelf.model.phone,
                                                    'email': modalSelf.credentials.userEmailField
                                                };

                                                // The invitation service always save the type as uppercase
                                                var promise = businessService.invitationCreate(memberinfo, 'ASSOCIATE');
                                                promise.then(function(response) {
                                                    if (response.data && response.data.invitation) {
                                                        var invitation = response.data.invitation;
                                                        self.model.associatesList = self.model.associatesList
                                                            ? self.model.associatesList : [];
                                                        self.model.associatesList.push({
                                                            'id': (self.model.associatesList.length - 1),
                                                            'firstName': invitation.guestFirstName,
                                                            'lastName': invitation.guestLastName,
                                                            'accountstatus': invitation.status,
                                                            'invitationUuId': invitation.UUID,
                                                            'contactpreference': {
                                                                'email': invitation.guestEmailAddress,
                                                                'phone': modalSelf.model.phoneAdd,
                                                                'contactpref': modalSelf.model.contactpref
                                                            },
                                                            'inviteStatus': [{
                                                                'id': 101,
                                                                'status': true,
                                                                'name': 'sent',
                                                                'label': 'Resend Invite'
                                                            }]
                                                        });
                                                    }
                                                }, function(error) {
                                                    // eslint-disable-next-line no-console
                                                    console.info(error);
                                                });
                                                modalSelf.ok();
                                            }
                                        }
                                    }
                                });
                            }
                        };
                    }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass
                });
            } else
            if (controller == 'directDeposit') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
                        var modalSelf = this;
                        modalSelf.model = {};

                        modalSelf.model.directDepositPolicyPopUp = $sce.trustAsHtml(strings
                            .get('tdc_directDepositPolicyPopUp'));
                        modalSelf.ok = function() {
                            $uibModalInstance.close();
                        };

                        modalSelf.cancel = function() {
                            $uibModalInstance.dismiss();
                        };

                        $scope.$on('$locationChangeStart', function($event) {
                            $uibModalInstance.dismiss();
                        });
                    }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass
                });
            } else
            if (controller == 'editProfile') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance',
                        'cropModalEvent',
                        'croppedImgData',
                        'editFormModel',
                        '$scope', function($uibModalInstance, cropModalEvent, croppedImgData, editFormModel, $scope) {
                            var modalSelf = this;
                            modalSelf.sizeLimit = 2; // 2MB is the size limit
                            model.userdata.profileImage = self.model.headerInfo.thumbnailURL;
                            model.userdata.firstname = self.model.headerInfo.firstName;
                            model.userdata.lastname = self.model.headerInfo.lastName;
                            model.userdata.preferredname = self.model.headerInfo.preferredname;
                            model.userdata.fullName = self.model.headerInfo.fullName;
                            modalSelf.uploadedImageBlob = null;
                            var accountType = [];
                            var accountTypeobj = model.userdata && model.userdata.accountType
                                ? $filter('filter')(model.userdata.accountType, {status: true})[0] : null;
                            accountType.push(accountTypeobj);

                            modalSelf.model = {
                                'profileImage': self.model.headerInfo.thumbnailURL
                                    ? self.model.headerInfo.thumbnailURL : null,
                                'defaultthumbnailURL': self.model.headerInfo.defaultthumbnailURL
                                    ? self.model.headerInfo.defaultthumbnailURL : null,
                                'accountType': accountType
                            };

                            $uibModalInstance.rendered.then(function(data) {
                                if (croppedImgData) {
                                    modalSelf.model.profileImage = croppedImgData;
                                } else {
                                    if (editFormModel) {
                                        modalSelf.model.profileImage = editFormModel.profileImage;
                                    } else {
                                        modalSelf.model.profileImage = self.model.headerInfo.thumbnailURL;
                                    }
                                }
                                if (editFormModel) {
                                    modalSelf.model.firstname = editFormModel.firstname;
                                    modalSelf.model.lastname = editFormModel.lastname;
                                    modalSelf.model.preferredname = editFormModel.preferredname;
                                } else {
                                    modalSelf.model.firstname = self.model.headerInfo.firstName;
                                    modalSelf.model.lastname = self.model.headerInfo.lastName;
                                    modalSelf.model.preferredname = self.model.headerInfo.preferredName;
                                }
                                // $scope.$apply(); - Commented as part of MEC-22294
                            }, function(err) {
                                // eslint-disable-next-line no-console
                                console.info(err);
                            });
                            modalSelf.ok = function() {
                                $uibModalInstance.close();
                            };

                            modalSelf.cancel = function() {
                                $uibModalInstance.dismiss();
                            };

                            $scope.$on('$locationChangeStart', function($event) {
                                $uibModalInstance.dismiss();
                            });

                            modalSelf.uploadFiles = function(files) {
                                var arrayOfFiles;
                                if (files instanceof Array) {
                                    modalSelf.Files = files;
                                    arrayOfFiles = files;
                                } else {
                                    arrayOfFiles = [];
                                    arrayOfFiles.push(files);
                                    modalSelf.Files = arrayOfFiles;
                                }

                                modalSelf.sizeLimitError = modalSelf.files && modalSelf.files.size
                                && (modalSelf.files.size / 1048576) > modalSelf.sizeLimit ? true : false;

                                if (!modalSelf.sizeLimitError) {
                                    // Upload Image
                                    var fileUploadPromise = businessService.uploadPhoto(files);
                                    fileUploadPromise.then(function(response) {
                                        modalSelf.uploadedImageBlob = response;
                                        modalSelf.editFormModel = {};
                                        modalSelf.editFormModel['firstname'] = modalSelf.model.firstname;
                                        modalSelf.editFormModel['lastname'] = modalSelf.model.lastname;
                                        modalSelf.editFormModel['preferredname'] = modalSelf.model.preferredname;
                                        modalSelf.editFormModel['profileImage'] = modalSelf.model.profileImage;
                                        $uibModalInstance.dismiss();
                                        showPictureCropModal(true, response, modalSelf.editFormModel);
                                    });
                                }
                            };

                            modalSelf.removeProfilePhoto = function() {
                                croppedImgData = modalSelf.model.profileImage = null;
                            };

                            modalSelf.updateProfilePic = function(response) {
                                if (response.profile) {
                                    modalSelf.model.profileImage = self.model.headerInfo.thumbnailURL
                                        = $rootScope.accImage = response.profile.thumbnailURL;
                                    self.model.headerInfo.profilePictureUrl = response.profile.photoURL;
                                } else if (response.indexOf('gigya') !== -1) {
                                    self.model.headerInfo.profilePictureUrl = modalSelf.model.profileImage
                                        = self.model.headerInfo.thumbnailURL = $rootScope.accImage = response;
                                } else {
                                    self.model.headerInfo.profilePictureUrl = modalSelf.model.profileImage
                                        = self.model.headerInfo.thumbnailURL = $rootScope.accImage = '';
                                    $rootScope.accImage = '';
                                }
                                modalSelf.updateProfileInHybris();
                            };

                            modalSelf.updateProfileInHybris = function() {
                                var hybrisCallPromise = businessService.setHeaderInfoHybris(modalSelf.model);
                                hybrisCallPromise.then(function(status) {
                                    if (status == 200 || status == 201) {
                                        model.headerInfo.firstName = modalSelf.model.firstname;
                                        model.headerInfo.lastName = modalSelf.model.lastname;
                                        model.headerInfo.preferredName = modalSelf.model.preferredname;
                                        // Close Modal Window

                                        $uibModalInstance.close();
                                    } else {
                                        $rootScope.$emit('isServiceCallFailure', serviceCallFailureMsg);
                                    }
                                });
                            };

                            modalSelf.saveFileUpload = function(isValid) {
                                if (isValid) {
                                    // Update form fileds
                                    if (modalSelf.model.preferredname != null && modalSelf.model.preferredname
                                        != undefined && modalSelf.model.preferredname != '') {
                                        model.isPreferredNamePresent = true;
                                        model.headerInfo.fullName= modalSelf.model.preferredname;
                                    } else {
                                        model.isPreferredNamePresent = false;
                                        model.headerInfo.fullName= modalSelf.model.firstname
                                            +' '+ modalSelf.model.lastname;
                                    }
                                    modalSelf.model.firstname = modalSelf.model.firstname
                                        ? modalSelf.model.firstname : '';
                                    modalSelf.model.lastname = modalSelf.model.lastname ? modalSelf.model.lastname : '';
                                    modalSelf.model.preferredname = modalSelf.model.preferredname
                                        ? modalSelf.model.preferredname : '';

                                    if (croppedImgData) {
                                        model.showLoader(true);
                                        // Save Profile Picture to Gigya
                                        var fileUploadToGigyaPromise = businessService
                                            .uploadPhotoToGigya(croppedImgData);
                                        fileUploadToGigyaPromise.then(function(response) {
                                            modalSelf.uploadRemoveErrorResponse = null;
                                            if (response.status == 'OK') {
                                                // Update Profile Picture
                                                gigya.accounts.getAccountInfo({callback: modalSelf.updateProfilePic});
                                            } else {
                                                // eslint-disable-next-line no-console
                                                console.info('Error uploading image files to Gigya.');
                                            }
                                        });
                                    } else {
                                        if (modalSelf.model.profileImage) {
                                            modalSelf.updateProfilePic(modalSelf.model.profileImage);
                                        } else {
                                            modalSelf.updateProfilePic(modalSelf.model.defaultthumbnailURL);
                                        }
                                    }

                                    // Update User Profile Manager
                                    var userProfileDetailInfo = userProfileManager.getUserProfileDetailInfo();
                                    userProfileDetailInfo.profileHeader.firstName = modalSelf.model.firstname;
                                    userProfileDetailInfo.profileHeader.lastName = modalSelf.model.lastname;
                                    userProfileDetailInfo.profileHeader.preferredName = modalSelf.model
                                        .preferredname;
                                    userProfileDetailInfo.profileHeader.profileThumbnailUrl = modalSelf.model
                                        .profileImage;
                                    userProfileManager.setUserProfileDetailInfo(userProfileDetailInfo);

                                    // Update Root Scope
                                    $rootScope.firstName = modalSelf.model.firstname;
                                    $rootScope.lastName = modalSelf.model.lastname;
                                    $rootScope.preferredName = modalSelf.model.preferredname;
                                }
                            };
                        }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass,
                    resolve: {
                        cropModalEvent: function() {
                            return (isCropModal) ? true : false;
                        },
                        croppedImgData: function() {
                            return croppedImg;
                        },
                        editFormModel: function() {
                            return editProfileCachedData;
                        }
                    }
                });

                modalInstance.result.then(function(data) {
                    // eslint-disable-next-line no-console
                    console.info('then', data);
                }, function(data) {
                    // eslint-disable-next-line no-console
                    console.info('error', data);
                });
            } else
            if (controller == 'termsAndConditions') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
                        var modalSelf = this;
                        modalSelf.model = {};

                        this.verNumber = accountConfigManager.site['TandCversionNumber'];

                        var tempPath;

                        tempPath = accountConfigManager.site['termsandconditionscontentpath'] || '';
                        this.tncpath = commonUtil.constructFullUrl(tempPath + '/' + countryCode + '/' + languageCode);
                        this.downloadPdf = tempPath + '/' + countryCode + '/' + languageCode + '.pdf';
                        this.downloadPdfName = 'business_' + languageCode;

                        this.distributorHeading = strings.get('tdc_distributorCompensationPopupHeading');
                        this.productPolicyHeading = strings.get('tdc_productPolicyPopUpHeading');
                        tempPath = accountConfigManager.site['distributorCompensationPath'] || '';
                        this.distributorSummaryPath = commonUtil.constructFullUrl(tempPath + '/'
                            + countryCode + '/distributorSummary_' + languageCode );
                        tempPath = accountConfigManager.site['productPolicyPath'] || '';
                        this.productPolicyPath = commonUtil.constructFullUrl(tempPath + '/'
                            + countryCode + '/productPolicy_' + languageCode);

                        this.popUpBackButtonLabel = strings.get('tdc_popUpBackButtonLabel');
                        this.popUpGoBackButtonLabel = strings.get('tdc_goBack');
                        this.policyCheckbox = false;
                        this.arbitrationPolicyCheckbox = false;
                        this.srcUrl = '';
                        this.showModal = false;
                        this.knowMore = function(linkType) {
                            if (linkType == 'compensationSummary') {
                                modalSelf.modalHeading = this.distributorHeading;
                                modalSelf.modalURL = this.distributorSummaryPath;
                            } else {
                                modalSelf.modalHeading = this.productPolicyHeading;
                                modalSelf.modalURL = this.productPolicyPath;
                            }
                            modalSelf.back = this.popUpBackButtonLabel;
                            modalSelf.goBack = this.popUpGoBackButtonLabel;
                            this.showModal = true;
                        };
                        this.hideCustomModal = function() {
                            this.showModal = false;
                        };
                        modalSelf.acceptTermsConditions = function() {
                            modalSelf.acceptButtonClicked = true;
                            if (modalSelf.policyCheckbox && modalSelf.arbitrationPolicyCheckbox) {
                                modalSelf.checkBoxes = false;

                                var promise = businessService.acceptButtonClicked(this.verNumber);

                                promise.then(function(data) {
                                    if (data == 200) {
                                        // Save Tax ID Here
                                        var bussName = model.businessDistributor.businessName
                                            ? model.businessDistributor.businessName.toUpperCase() : '';
                                        var taxID = model.businessDistributor.taxId1 + model.businessDistributor.taxId2;
                                        var promise = businessService.saveTaxID(bussName, taxID);
                                        promise.then(function successCallback(data) {
                                            if (data == 200) {
                                                model.isSuccess = true;
                                                model.duplicateTaxID = false;
                                                modalSelf.ok();
                                                modalPopupInstance(confirmationModalTemplate, 'confirmation',
                                                    'app-modal-window confirmation-popup  business-section-popup');
                                            }
                                            if (!model.isSuccess) {
                                                model.invalidTaxID = true;
                                            }
                                        }, function failureCallback(response) {
                                            if (response.status == 400) {
                                                model.isSuccess = false;
                                                model.duplicateTaxID = true;
                                            }
                                        });
                                    }
                                });
                            } else {
                                modalSelf.checkBoxes = true;
                            }
                        };

                        this.checkboxShowHide = function() {
                            if (self.acceptButtonClicked) {
                                if (this.policyCheckbox && this.arbitrationPolicyCheckbox) {
                                    self.checkBoxes = false;
                                } else {
                                    self.checkBoxes = true;
                                }
                            }
                        };

                        this.arbitrationPolicyLink = function() {
                            $window.location.hash = '#arbPolicy';
                        };

                        this.limitationLiabilityLink = function() {
                            $window.location.hash = '#limitationPolicy';
                        };

                        this.indemnificationLink = function() {
                            $window.location.hash = '#indemnificationPolicy';
                        };


                        modalSelf.cancelTermsConditions = function() {
                            modalSelf.cancel();
                        };

                        modalSelf.slickPrimaryConfig = {
                            enabled: true,
                            infinite: false,
                            adaptiveHeight: false,
                            mobileFirst: true,
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            dots: false,
                            speed: 500,
                            responsive: [{
                                breakpoint: 320,
                                settings: {
                                    slidesToShow: 1,
                                }
                            }, {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 2,
                                }
                            }, {
                                breakpoint: 1023,
                                settings: {
                                    slidesToShow: 3,
                                    draggable: false,
                                }
                            }, {
                                breakpoint: 1440,
                                settings: {
                                    slidesToShow: 3,
                                    draggable: false,
                                }
                            }]
                        };

                        modalSelf.businessImageList = model.businessImageList;

                        modalSelf.ok = function() {
                            $uibModalInstance.close();
                        };

                        modalSelf.cancel = function() {
                            $uibModalInstance.dismiss();
                        };

                        modalSelf.cancelAndExit = function() {
                            modalSelf.cancel();
                            self.showBusinessDistributorForm = false;
                        };

                        this.download = function() {
                            var link = angular.element('<a></a>');
                            link.attr('href', this.downloadPdf);
                            link.attr('download', this.downloadPdfName);
                            link[0].click();
                        };

                        modalSelf.skipForNowShow = function() {
                            modalSelf.ok();
                            modalPopupInstance(skipForNowModal, 'skipForNow', 'app-modal-window skip-now-modal-body');
                        };

                        $scope.$on('$locationChangeStart', function($event) {
                            $uibModalInstance.dismiss();
                        });
                    }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass
                });
            } else
            if (controller == 'skipForNow') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
                        var modalSelf = this;
                        modalSelf.model = {};

                        var declinepath = strings.get('declinepath');

                        modalSelf.ok = function() {
                            $uibModalInstance.close();
                        };

                        modalSelf.cancel = function() {
                            $uibModalInstance.dismiss();
                        };
                        modalSelf.skipForNowClose = function() {
                            modalSelf.ok();
                            modalPopupInstance(termsModalTemplate, 'termsAndConditions',
                                'app-modal-window terms-conditions-modal-body');
                        };
                        modalSelf.remindLater = function() {
                            $uibModalInstance.dismiss();
                            $window.location.href = commonUtil.constructFullUrl(declinepath);
                        };
                        $scope.$on('$locationChangeStart', function($event) {
                            $uibModalInstance.dismiss();
                        });
                    }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass
                });
            } else
            if (controller == 'confirmation') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
                        var modalSelf = this;
                        modalSelf.model = {};
                        /* Note about ok/cancel/confirmAndClose.
                         * When this modal loads the user has already been convert
                         * to business distributor in the backend.
                         * This is just an informative window. Hence refreshAccountDetails() is called for all  cases
                         *
                         */

                        modalSelf.ok = function() {
                            $uibModalInstance.close();
                            self.refreshAccountDetails();
                        };

                        modalSelf.cancel = function() {
                            $uibModalInstance.dismiss();
                            self.refreshAccountDetails();
                        };

                        modalSelf.confirmAndClose = function() {
                            $uibModalInstance.close();
                            self.refreshAccountDetails();
                        };
                        $scope.$on('$locationChangeStart', function($event) {
                            $uibModalInstance.dismiss();
                        });
                    }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass
                });
            }

            if (controller == 'addressVerification') {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: modalTemplateVariable,
                    controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
                        var modalSelf = this;
                        modalSelf.model = {};
                        modalSelf.model.addressList = self.addressList;
                        modalSelf.addressData = self.addressJsonDataForModal;
                        modalSelf.suggestionsData = self.suggestionsData;
                        modalSelf.invalidAddress = self.invalidAddress;

                        modalSelf.ok = function() {
                            $uibModalInstance.close();
                        };

                        modalSelf.cancel = function() {
                            $uibModalInstance.dismiss();
                        };

                        modalSelf.goBackAndEdit = function() {
                            modalSelf.cancel();
                        };

                        modalSelf.goWithSelectedAddress = function(isValid, selectedObject) {
                            if (isValid) {
                                modalSelf.useEnteredAddress(selectedObject);
                            }
                        };

                        modalSelf.useEnteredAddress = function(addressDataObj) {
                            if (addressDataObj) {
                                addressDataObj.addressLine1 = addressDataObj.addressLine1
                                    ? addressDataObj.addressLine1.toUpperCase() : '';
                                addressDataObj.addressLine2 = addressDataObj.addressLine2
                                    ? addressDataObj.addressLine2.toUpperCase() : '';
                                addressDataObj.city = addressDataObj.city ? addressDataObj.city.toUpperCase() : '';
                            } else {
                                self.addressJsonDataForModal.addressLine1 = self.addressJsonDataForModal.addressLine1
                                    ? self.addressJsonDataForModal.addressLine1.toUpperCase() : '';
                                self.addressJsonDataForModal.addressLine2 = self.addressJsonDataForModal.addressLine2
                                    ? self.addressJsonDataForModal.addressLine2.toUpperCase() : '';
                                self.addressJsonDataForModal.city = self.addressJsonDataForModal.city
                                    ? self.addressJsonDataForModal.city.toUpperCase() : '';
                            }
                            modalSelf.finalAddressData = addressDataObj ? addressDataObj : self.addressJsonDataForModal;
                            model.saveAddressOnSuccess(modalSelf.finalAddressData);
                            modalSelf.ok();
                        };

                        $scope.$on('$locationChangeStart', function($event) {
                            $uibModalInstance.dismiss();
                        });
                    }],
                    controllerAs: 'ctrl',
                    windowClass: windowClass
                });
            }
        };

        var showPictureCropModal = function(isModalProfilePic, imageFileBlob, editFormModel) {
            if (isModalProfilePic) {
                var pictureModalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: cropModalMarkup,
                    controller: ['$uibModalInstance',
                        'uploadedImageFileBlob',
                        'editFormModel',
                        '$scope', function($uibModalInstance, uploadedImageFileBlob, editFormModel, $scope) {
                            var pictureModalSelf = this;
                            var rotationDegrees = 0;
                            pictureModalSelf.profilePictureBlob = uploadedImageFileBlob;
                            pictureModalSelf.csstransition = '800ms ease';
                            pictureModalSelf.cssrotate = 'rotate(' + rotationDegrees + 'deg)';
                            pictureModalSelf.rotation = {};
                            pictureModalSelf.croppedImg = null;
                            pictureModalSelf.editFormModel = editFormModel;

                            $uibModalInstance.rendered.then(function(data) {
                                $('#crop-image-b').cropper({
                                    aspectRatio: 1 / 1,
                                    scalable: false,
                                    movable: false,
                                    zoomable: false
                                });
                            }, function(data) {
                                // eslint-disable-next-line no-console
                                console.info('Error opening modal window');
                            });

                            pictureModalSelf.savePicture = function() {
                                pictureModalSelf.croppedImg = pictureModalSelf.editFormModel.profileImage
                                    = $('#crop-image-b').cropper('getCroppedCanvas').toDataURL();

                                $uibModalInstance.close(pictureModalSelf);
                            };

                            pictureModalSelf.cancelPicture = function() {
                                pictureModalSelf.croppedImg = '';
                                $uibModalInstance.close(pictureModalSelf);
                            };

                            pictureModalSelf.rotatePicture = function(direction) {
                                if (direction) {
                                    $('#crop-image-b').cropper('rotate', -90);
                                } else {
                                    $('#crop-image-b').cropper('rotate', 90);
                                }
                            };

                            $scope.$on('$locationChangeStart', function($event) {
                                $uibModalInstance.dismiss();
                            });
                        }],
                    controllerAs: 'ctrl',
                    windowClass: 'app-modal-window modal-crop-photo',
                    resolve: {
                        uploadedImageFileBlob: function() {
                            if (imageFileBlob) {
                                return imageFileBlob;
                            }
                        },
                        editFormModel: function() {
                            if (editFormModel) {
                                return editFormModel;
                            }
                        }
                    }
                });

                pictureModalInstance.result.then(function(data) {
                    modalPopupInstance(fileUploadModalTemplate, 'editProfile',
                        'app-modal-window file-upload-popup personal-section-popup', true,
                        data.croppedImg, data.editFormModel);
                }, function() {
                    modalPopupInstance(fileUploadModalTemplate, 'editProfile',
                        'app-modal-window file-upload-popup personal-section-popup', false);
                });
            }
        };

        model.inlineEditForAddress = function() {
            model.showAddressForm = true;
            model.showCheckBox = true;
        };

        var accountManagerPromise = businessService.getAccountManager();
        accountManagerPromise.then(function(data) {
            if (typeof data != 'undefined' && data != null && data != '') {
                if (typeof data != 'object') {
                    data.trim();
                }
                if (data !== 'null') {
                    model.distInfo = data;
                    var accountManagers = undefined;
                    if (data.distInfo) {
                        accountManagers = data.distInfo.primaryAM;
                    }
                    if (accountManagers) {
                        if (Object.prototype.toString.call(accountManagers) == '[object Array]') {
                            model.accountManager = accountManagers[0];
                        } else if (Object.prototype.toString.call(accountManagers) == '[object Object]') {
                            model.accountManager = accountManagers;
                        } else {
                            model.accountManager = undefined;
                        }

                        model.hasAccountManager = true;
                    }
                }
            }
        });


        var headerDetailsPromise = businessService.getHeaderDetails();
        headerDetailsPromise.then(function(data) {
            if (data.person) {
                model.headerInfo.firstName = data.person.names.local.given;
                model.headerInfo.lastName = data.person.names.local.family;

                if (data.person.preferredName) {
                    model.isPreferredNamePresent = true;
                    model.headerInfo.preferredName = data.person.preferredName;
                    model.headerInfo.fullName = model.headerInfo.preferredName;
                }

                model.headerInfo.thumbnailURL = data.person.profileThumbnailUrl;
                model.headerInfo.profilePictureUrl = data.person.profilePictureUrl;
                model.headerInfo.accountID = data.person.accountID;
            }

            if (data.person.address) {
                model.contactAddress.line1 = data.person.address.line1;
                model.contactAddress.line2 = data.person.address.line2;
                model.contactAddress.city = data.person.address.city;
                if (data.person.address.region) {
                    var stateCountry = data.person.address.region.split('-');
                    model.contactAddress.state = stateCountry[0];
                }
                model.contactAddress.postalCode = parseInt(data.person.address.postalCode);
            }
        });

        var invitationListPromise = businessService.invitationList();
        invitationListPromise.then(function(response) {
            if (response && response.data && response.data.invitation) {
                var sentLabel = strings.get('tdc_sentLabel');
                var resendInviteLabel = strings.get('tdc_resendInviteLabel');
                response.data.invitation.forEach(function(item) {
                    if (item.type == 'ASSOCIATE') {
                        // This logic may need to change.  The status does NOT have "Completed"?
                        if ((item.guestEmailAddress != model.userInfo.emailId) && item.status != 'ACKNOWLEDGED') {
                            self.model.associatesList.push({
                                'id': (self.model.associatesList.length - 1),
                                'firstName': item.guestFirstName,
                                'lastName': item.guestLastName,
                                'accountstatus': item.status,
                                'invitationUuId': item.UUID,
                                'contactpreference': {
                                    'phone': '',
                                    'email': (item.guestEmailAddress != null) ? item.guestEmailAddress : '',
                                    'contactpref': ''
                                },
                                'inviteStatus': [{
                                    'id': 101,
                                    'status': true,
                                    'name': sentLabel,
                                    'label': resendInviteLabel
                                }]
                            });
                        }
                    }
                });
            }
        });


        this.manageSameAddressCheckbox = function() {
            model.enterAddress = angular.copy(model.contactAddress);
        };

        this.refreshAccountDetails = function() {
            self.showBusinessDistributorForm = false;

            /* Refreshing the data */
            var promise = businessService.loadDetails(model.userType);
            promise.then(function(data) {
                // overview processing
                model.accountOriginal = data.account.header;
                model.accountType = data.account.bankInfo.accountType;
                angular.extend(model.account, model.accountOriginal);
                angular.extend(model.userdata, model.userdataOriginal);
                model.account.taxID = model.businessDistributor.taxId1 + model.businessDistributor.taxId2;
            });
        };

        model.showLoader = function(showgloballoader) {
            if (showgloballoader == false) {
                $rootScope.showGlobalLoader = false;
                angular.element(document.querySelector('loader-component')).removeClass('modal-open');
                angular.element(document.querySelector('body')).css('overflow', '');
            } else {
                if (showgloballoader == true) {
                    $rootScope.showGlobalLoader = true;
                    $timeout(function() {
                        if ($rootScope.showGlobalLoader) {
                            angular.element(document.querySelector('loader-component')).removeClass('modal-open');
                            angular.element(document.querySelector('body')).css('overflow', '');
                            $rootScope.showGlobalLoader = false;
                        }
                    }, 15000);
                    angular.element(document.querySelector('loader-component')).addClass('modal-open');
                    angular.element(document.querySelector('body')).css('overflow', 'hidden');
                }
            }
        };


        model.seeMore = function() {
            model.setShowMore = true;
        };

        model.seeLess = function() {
            model.setShowMore = false;
        };

        model.showBankCheckExmpl = function() {
            $timeout(function() {
                angular.element('.bank-example-hyperlink div h4 a').trigger('click');
            });
        };

        model.scrollIntoView = function(str) {
            angular.element('#tab-'+str+'-heading')[0].scrollIntoView(true);
        };

        angular.element('#accordion').on('shown.bs.collapse', function(event) {
            businessService.scrollToTop(event.target.parentElement);
        });

        model.cancelBusinessConversion = function() {
            model.showBusinessConversionForm = false;
            model.businessTaxId = '';
            model.taxIdDisplay = [];
        };

        model.saveBusinessConversion = function(isValid) {
            if (isValid && model.businessTaxId && model.taxIdUtils.isValidTaxId(model.businessTaxId)) {
                var formattedTaxId = formatTaxId(model.businessTaxId);
                var payload = getBusinessConversionPayload(formattedTaxId, model.businessDistributor.businessName);

                var promise = businessService.convertToBusiness(payload);
                promise.then(function(response) {
                    var data = response.data;
                    if (data.status === 200 || data.status === 201) {
                        model.showBusinessConversionForm = false;
                        model.accountType = 'COMPANY';
                        model.accountTypeDisplay = setAccountTypeDisplay(model.accountType);
                        model.businessName = data.account.names.local;
                        model.businessTaxId = data.account.legalIDs[0].value;
                    } else {
                        model.showBusinessConversionForm = true;
                    }
                });
            }
        };
        // -----------------------------------------------------------
        //
        //               Private methods
        //
        // -----------------------------------------------------------

        var formatTaxId = function(taxId) {
            var taxIdData = {
                type: model.taxIdConfigs.fieldInService,
                value: taxId
            };

            return model.taxIdUtils.formatToService(taxIdData);
        };

        var getBusinessConversionPayload = function(formattedTaxId, businessName) {
            var payload = {};
            payload.legalID = formattedTaxId.legalID;
            payload.country = model.countryCode;
            payload.companyName = businessName;

            return payload;
        };
    }]);



//////////////////
// WEBPACK FOOTER
// ./views/pages/business/business.js
// module id = 373
// module chunks = 0